
import React, { useEffect, useState } from 'react'
import { Badge, Col, Container, Form, Row } from 'react-bootstrap'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomTable from '../Components/CustomTable/CustomTable'
import CustomPagination from '../Components/CustomPagination/CustomPagination'
import { useDispatch, useSelector } from 'react-redux'
import { fetchRestaurants } from '../hooks/resturant'
import { deleteMainMeal, fetchMainMeals } from '../hooks/MainMeals'
import { useNavigate } from 'react-router-dom'
import CustomModal from '../Components/CustomModal/CustomModal'

function MainMeals() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { list, Pagination } = useSelector((state) => state.resturants);
  const { list: MainMealsList, Pagination: MainMealsPagination } = useSelector((state) => state.mainMeals);
  const [resturantID, setResturantID] = useState(null)
  const [selectedRestaurant, setSelectedRestaurant] = useState("all");
  const [mealsState, setMealsState] = useState([]);
  const { list: resturants, Pagination: Paginationresturants } = useSelector((state) => state.resturants);
  const [deleteShowModal, setDeleteShowModal] = useState(false);
  const [itemID, setItemID] = useState(null)
  const traineesData = MainMealsList.filter((t) => {
    
  if (selectedRestaurant === "all") return true;
  return t.restaurants?.[0]?.id == selectedRestaurant;
});
  const resturantsData = list.map((item) => ({
    id: item?.id,
    name: item?.name
  }));

  useEffect(() => {
    if (MainMealsList) {
      setMealsState(MainMealsList);
    }
  }, [MainMealsList]);
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    if (list?.length > 0 && !resturantID) {
      setResturantID(list[0].id);
    }
  }, [list]);
  const handleToggle = (id) => {
    setMealsState((prev) =>
      prev.map((meal) =>
        meal.id === id
          ? { ...meal, active: !meal.active }
          : meal
      )
    );
  };
  useEffect(() => {
    dispatch(fetchMainMeals());
    // dispatch(fetchMainMeals({
    //   page: currentPage,
    //   ...(resturantID && { restaurant_id: resturantID })
    // }));
  }, [currentPage, resturantID]);
  const header = [
    "اسم",
    "اسم الوجبة الاساسية",
    "اسم المطعم",
    "التاريخ",
    "اليوم",
    // "",
    "",
    "",

  ]
const deleteItem=()=>{
      dispatch(deleteMainMeal(itemID))
        .unwrap() // Allows us to use .then() / .catch() on the thunk result
        .then(() => {
  dispatch(fetchMainMeals())
          alert(`تم المسح الوجبة بنجاح`);
setDeleteShowModal(false)
          
        })
        .catch((err) => {
          // Error is already handled in Redux, but you can do specific UI logic here
          console.error("Failed to save:", err);
        });
  
}
  const body = <tbody>

    {traineesData?.filter((meal) => meal.parent).map((item) => {
      return (
        <tr>
          <td> {item?.name}</td>
          <td> {item?.parent?.name}</td>
          <td> {item?.restaurants?.[0]?.name}</td>
                    <td> {item?.date}</td>
          <td> {item?.day}</td>

          {/* <td>
            <Form.Check // prettier-ignore
              type="switch"
              checked={item.is_active}
              onChange={() => handleToggle(item.id)}

            />
          </td> */}
          <td> <Badge bg={'primary'} onClick={()=>navigate(`/dashboard/meal/${item?.id}`)}>تعديل</Badge></td>
          <td> <Badge bg={'danger'} 
          onClick={()=>{
            setItemID(item?.id)
            setDeleteShowModal(true)
          }}
          >مسح</Badge></td>



        </tr>
      )
    })}

  </tbody>
  const fiteration = [
    { id: 0, title: "الوجبات", options: resturantsData },
  ]

  return (
    <div>
                <CustomModal show={deleteShowModal} onHide={() => setDeleteShowModal(false)}ar_status={'الوجبة'} deleteItem={deleteItem}/>
      
      <AuthNavbar />
      <Container>
        <CustomHeader
          title={"قائمة الوجبات الاساسية"}
          subtitle={""}
          downloadData={false}
          addData={true}
          status={"main-meals"}
        />
        <Row>
          <Col md={4}>
            <select
              className="form-control"
              value={selectedRestaurant}
              onChange={(e) => setSelectedRestaurant(e.target.value)}
            >
              <option value="all">كل المطاعم</option>
              {resturants.map((r) => (
                <option key={r.id} value={r.id}>
                  {r.name}
                </option>
              ))}
            </select>
          </Col>
        </Row>
        <CustomTable
          data={MainMealsList}
          fiteration={[]}
          currentData={10}
          allData={` ${Pagination?.total} مطعم`}
          header={header}
          activeStatus={true}
          actions={["تعديل", "حذف"]}
          status={"main-meals"}
          ar_status={"الوجبة الرئيسية"}
          currentPage={currentPage}
          setResturantID={setResturantID}
          resturantID={resturantID}
          body={body}


        />
        <CustomPagination
          currentPage={currentPage}
          totalPages={Math.ceil(Pagination?.total / Pagination?.per_page) || 1}  // allData={Pagination?.total || 1}
          // activePage={rowsPerPage}
          setCurrentPage={setCurrentPage}
        // setRowsPerPage={setRowsPerPage}

        />
      </Container>
    </div>
  )
}

export default MainMeals
